// ============================================================
//  ZENTRALE SITE-KONFIGURATION — Team Sempachersee
//  Rebranding: nur diese Datei + src/index.css anpassen.
// ============================================================
export const site = {
  name: "Team Sempachersee",
  shortName: "TSS",
  tagline: "Nachwuchsfussball am Sempachersee",
  url: "https://team-sempachersee.ch",

  contact: {
    email: "info@team-sempachersee.ch",
    phone: "+41 79 370 28 37",
    address: "c/o Urs Ottiger, Seeparkstrasse 2, 6207 Nottwil",
  },

  social: {
    instagram: "",
    facebook: "",
  },

  // Navigation: Reihenfolge = Anzeige in der Navbar
  nav: [
    { label: "Home",      path: "/" },
    { label: "News",      path: "/news" },
    { label: "Teams",     path: "/teams" },
    { label: "Sponsoren", path: "/sponsoren" },
    { label: "Kontakt",   path: "/kontakt" },
  ],
};
